const API_URL = window.location.origin;

export const api = async (path, options = {}) => {
  const res = await fetch(`${API_URL}/api/sales-targets${path}`, {
    ...options,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}`, 'Content-Type': 'application/json', ...(options.headers || {}) },
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.detail || 'Request failed');
  return data;
};

export const inr = (v) => new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', maximumFractionDigits: 0 }).format(v || 0);
export const crore = (v) => {
  const n = v || 0;
  if (Math.abs(n) >= 1e7) return `₹${(n / 1e7).toFixed(2)} Cr`;
  if (Math.abs(n) >= 1e5) return `₹${(n / 1e5).toFixed(2)} L`;
  return `₹${Math.round(n).toLocaleString('en-IN')}`;
};

export const nextFy = (fy) => {
  const s = parseInt(fy.slice(2, 4), 10) + 1;
  const pad = (n) => String(n % 100).padStart(2, '0');
  return `FY${pad(s)}-${pad(s + 1)}`;
};

export const fyOptions = (current, existing = []) => {
  const s = parseInt(current.slice(2, 4), 10);
  const pad = (n) => String(((n % 100) + 100) % 100).padStart(2, '0');
  const list = [-1, 0, 1, 2].map(d => `FY${pad(s + d)}-${pad(s + d + 1)}`);
  return Array.from(new Set([...existing, ...list])).sort().reverse();
};

export const inputBase = 'px-3 py-2 border border-slate-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-slate-900 text-sm bg-white';
export const inputCls = `w-full ${inputBase}`;
